var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      visible: _vm.visible,
      width: 880,
      height: 760,
      title: _vm.$t("回放"),
      wrapClassName: "rrweb-container",
      closable: false,
      footer: null
    },
    on: {
      ok: _vm.handleOk
    }
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.spinning,
      expression: "spinning"
    }],
    staticClass: "loading-container"
  }, [_c("a-spin", {
    attrs: {
      spinning: _vm.spinning,
      tip: _vm.$t("视频数据过大，加载中，请稍后")
    }
  })], 1), _c("div", {
    attrs: {
      id: "playback"
    }
  }), _c("div", [_c("a-button", {
    staticStyle: {
      "margin-top": "24px",
      "margin-left": "760px"
    },
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.handleOk
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))])], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };